module.exports = __webpack_public_path__ + "img/office_dialog_icon02.e34a4730.png";